import React from "react";
import { TASK_LABEL } from "./taskCopy";
import "./TaskRow.css";

export default function TaskRow({
  item,
  selected = false,
  compact = false,
  onOpen,
  mutateAllowed = false,
  archivingId = null,
  onArchive,
}) {
  const open = (event) => {
    if (event) event.preventDefault();
    if (typeof onOpen === "function") onOpen(item.id, item.action?.section);
  };

  return (
    <article
      className={`task-row plan-list-item${compact ? " is-compact" : ""}${selected ? " is-selected selected" : ""}${item.waitingOnYou ? " needs-you" : ""}`}
      data-testid={`task-row-${item.id}`}
      data-waiting-on-you={item.waitingOnYou ? "true" : "false"}
      data-group={item.group}
      onClick={(event) => {
        if (event.target.closest(".task-row-archive")) return;
        open(event);
      }}
    >
      <button
        type="button"
        className="task-row-main"
        data-testid={`mission-task-${item.id}`}
        aria-label={`Open ${TASK_LABEL}: ${item.title}. ${item.statusLabel} ${item.ownerLabel}.`}
        onClick={open}
      >
        <div className="task-row-copy">
          <h4 className="task-row-title">{item.title}</h4>
          {!compact && item.outcome ? <p className="task-row-outcome">{item.outcome}</p> : null}
          {!compact && item.similarCount > 1 ? (
            <p className="task-row-similar">{item.similarCount} similar Tasks. Open the one you meant.</p>
          ) : null}
        </div>
        <div className="task-row-meta">
          <p className="task-row-status">{item.statusLabel}</p>
          {compact ? null : <p className="task-row-owner">{item.ownerLabel}</p>}
        </div>
        {compact ? null : <p className="task-row-updated">{item.updatedLabel}</p>}
      </button>
      <div className="task-row-actions">
        {compact ? null : (
          <button
            type="button"
            className="task-row-action"
            onClick={open}
          >
            {item.action?.label || "Open Task"}
          </button>
        )}
        {mutateAllowed && typeof onArchive === "function" ? (
          <button
            type="button"
            className="task-row-archive"
            data-testid={`task-delete-${item.id}`}
            aria-label={`Archive ${TASK_LABEL}: ${item.title}`}
            disabled={archivingId === item.id}
            onClick={(event) => {
              event.stopPropagation();
              onArchive(item.id);
            }}
          >
            {archivingId === item.id ? "Archiving…" : "Archive"}
          </button>
        ) : null}
      </div>
    </article>
  );
}
